document.querySelectorAll('[data-rtr]').forEach((section) => {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';

  const track = section.querySelector('[data-rtr-track]');
  const originals = track ? [...track.children] : [];
  if (!track || originals.length < 2) return;

  const cloneCard = (node) => {
    const clone = node.cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    clone.setAttribute('aria-hidden', 'true');
    return clone;
  };

  const before = originals.map(cloneCard);
  const after = originals.map(cloneCard);
  track.prepend(...before);
  track.append(...after);

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const delay = Math.max(1000, Number(section.dataset.delay || 6000));
  const count = originals.length;
  let timer;
  let settleTimer;
  let pointer;
  let stopped = false;
  let resetting = false;
  let pendingMove = 0;

  const cards = () => [...track.children];
  const cardLeft = (card) => {
    if (!card) return 0;
    const trackRect = track.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    return track.scrollLeft + (cardRect.left - trackRect.left);
  };

  const nearest = () => {
    const list = cards();
    return list.reduce((best, card, index) => {
      const currentDistance = Math.abs(cardLeft(card) - track.scrollLeft);
      const bestDistance = Math.abs(cardLeft(list[best]) - track.scrollLeft);
      return currentDistance < bestDistance ? index : best;
    }, 0);
  };

  const canonicalIndex = (index) => {
    const normalized = ((index % count) + count) % count;
    return normalized + count;
  };

  const jump = (index, callback) => {
    const card = cards()[index];
    if (!card) return;

    resetting = true;
    const previousSnap = track.style.scrollSnapType;
    const previousBehavior = track.style.scrollBehavior;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = cardLeft(card);

    requestAnimationFrame(() => {
      track.style.scrollSnapType = previousSnap;
      track.style.scrollBehavior = previousBehavior;
      resetting = false;
      callback?.();

      if (pendingMove && !resetting) {
        const direction = pendingMove;
        pendingMove = 0;
        move(direction);
      }
    });
  };

  const settle = () => {
    if (resetting) return;
    const index = nearest();
    if (index < count || index >= count * 2) jump(canonicalIndex(index));
  };

  const scrollToIndex = (index) => {
    const target = cards()[index];
    if (!target) return;
    track.scrollTo({ left: cardLeft(target), behavior: reduced ? 'auto' : 'smooth' });
  };

  const move = (direction) => {
    if (resetting) {
      pendingMove = direction;
      return;
    }

    const current = nearest();
    const canonical = canonicalIndex(current);
    const performMove = (fromIndex) => {
      const targetIndex = fromIndex + direction;
      scrollToIndex(targetIndex);
    };

    // Before every manual/automatic step, bring clone positions back to the
    // middle set. This prevents desktop controls from getting stuck at the
    // physical beginning/end of the three-set track.
    if (current < count || current >= count * 2) {
      jump(canonical, () => performMove(canonical));
    } else {
      performMove(current);
    }
  };

  const pause = () => {
    if (timer) clearInterval(timer);
    timer = undefined;
  };

  const start = () => {
    pause();
    if (!stopped && section.dataset.autoplay === 'true' && !reduced) {
      timer = setInterval(() => move(1), delay);
    }
  };

  const stop = () => {
    stopped = true;
    pause();
  };

  section.querySelector('[data-rtr-prev]')?.addEventListener('click', () => {
    stop();
    move(-1);
  });

  section.querySelector('[data-rtr-next]')?.addEventListener('click', () => {
    stop();
    move(1);
  });

  track.addEventListener('scroll', () => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 180);
  }, { passive: true });

  track.addEventListener('scrollend', settle, { passive: true });

  track.addEventListener('pointerdown', (event) => {
    pointer = { x: event.clientX, y: event.clientY };
    stop();
  }, { passive: true });

  track.addEventListener('pointerup', (event) => {
    if (!pointer) return;
    const deltaX = Math.abs(event.clientX - pointer.x);
    const deltaY = Math.abs(event.clientY - pointer.y);
    pointer = null;
    if (deltaX > 10 && deltaX > deltaY) stop();
  }, { passive: true });

  track.addEventListener('pointercancel', () => {
    pointer = null;
  }, { passive: true });

  track.addEventListener('wheel', stop, { passive: true });
  track.addEventListener('touchstart', stop, { passive: true });
  track.addEventListener('keydown', stop);
  track.addEventListener('focusin', stop);

  const resizeObserver = new ResizeObserver(() => {
    if (!resetting) jump(canonicalIndex(nearest()));
  });
  resizeObserver.observe(track);

  requestAnimationFrame(() => {
    jump(count, start);
  });
});
